import { JobDetailsDrawer } from '@client/components/_business/jobs/JobDetailsDrawer';
import { PageController } from '@client/components/_core/layout/PageController';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';

export const Route = createFileRoute('/admin-console/advanced/jobs/recurring/$jobId')({
    staticData: {
        presentation: 'overlay',
        breadcrumb: { title: 'Recurring job details' },
        ui: {
            title: 'Recurring job details',
        },
    },
    component: RecurringJobDetail,
});

function RecurringJobDetail() {
    const { jobId } = Route.useParams();
    const navigate = useNavigate();
    const [open, setOpen] = useState(true);

    const handleClose = () => {
        setOpen(false);
        // Navigate back to the recurring jobs list after drawer animation
        setTimeout(() => {
            navigate({ to: '/admin-console/advanced/jobs/recurring' });
        }, 300);
    };

    return (
        <PageController route={Route}>
            <JobDetailsDrawer jobId={jobId} jobType="recurring" open={open} onClose={handleClose} />
        </PageController>
    );
}
